import React, { Component } from 'react';
import * as grpcWeb from 'grpc-web';
import { Product, DisplayProduct } from "../components/suppliers/product";
import { convertErrorMessage, getAuthMetadata } from '../helpers/rpc';
import { ZandersProduct as ZandersProductPb, GetZandersProductRequest } from '../rpc/admin/zanders_pb';
import { SearchRequest, Hit, SearchResponse } from '../rpc/admin/search_pb';
import { Supplier } from '../rpc/admin/suppliers_pb';
import { AdminServiceClient } from '../rpc/admin/AdminServiceClientPb';
import { getBaseApiUrl } from '../helpers/instance';
import { getUser } from '../helpers/user';
import { logOut } from '../helpers/login';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface MatchParams {
    id: string;
}

interface ZandersProps {}

interface ZandersState {
    product?: DisplayProduct;
    supplierProducts: Hit[];
    errorMessage: string;
}

class ZandersProduct extends Component<ZandersProps & RouteComponentProps<MatchParams>, ZandersState> {

    constructor(props: ZandersProps & RouteComponentProps<MatchParams>) {
        super(props);
        this.state = {
            supplierProducts: [],
            errorMessage: ''
        };
    }

    private updateProduct(product: ZandersProductPb) {
        const displayProduct = new DisplayProduct();
        displayProduct.supplier = Supplier.SUPPLIER_ZANDERS;
        displayProduct.sku = product.getItemno();
        displayProduct.title = product.getDescription();
        displayProduct.description = product.getTextDescription();
        displayProduct.manufacturer = product.getManufacturer();
        displayProduct.price = product.getPrice() * 100;
        displayProduct.mapp = product.getMapprice() * 100;
        displayProduct.msrp = product.getMsrp() * 100;
        displayProduct.images = product.getImagesList();
        displayProduct.qoh = product.getQtyavail();

        Product.maybeAddStringAttribute(displayProduct, 'UPC', product.getUpc());
        Product.maybeAddStringAttribute(displayProduct, 'Sale Start', product.getSaleStart());
        Product.maybeAddStringAttribute(displayProduct, 'Sale End', product.getSaleEnd());
        if (product.getSaleStart()) {
            Product.addNumberAttribute(displayProduct, 'Sale Price', product.getSalePrice());
        }
        Product.maybeAddStringAttribute(displayProduct, 'Category', product.getCategoryname());
        Product.addBooleanAttribute(displayProduct, 'Serialized', product.getSerialized());

        product.getAttributesList().forEach((attribute) => {
            displayProduct.attributes.push({
                key: attribute.getAttribute(),
                value: attribute.getValue(),
            });
        });

        this.setState({
            product: displayProduct,
        })
    }

    componentDidMount() {
        if (!getUser()) {
            logOut();
            return;
        }

        let itemno: string;
        const id = this.props.match.params.id;
        if (typeof id === 'string') {
            itemno = id;
        } else {
            this.setState({
                errorMessage: 'Product not found',
            });
            return;
        }

        this.setState({
            errorMessage: '',
        });

        const client = new AdminServiceClient(getBaseApiUrl(), null, null);
        const request = new GetZandersProductRequest();
        request.setItemno(itemno);
        client.getZandersProduct(request, getAuthMetadata(), (err: grpcWeb.Error, response: ZandersProductPb) => {
            if (!err) {
                this.updateProduct(response);

                if (response.getUpc()) {
                    const searchRequest = new SearchRequest();
                    searchRequest.setQuery(response.getUpc());
                    client.supplierSearch(searchRequest, getAuthMetadata(), (err: grpcWeb.Error, searchResponse: SearchResponse) => {
                        if (!err) {
                            const hits: Hit[] = [];
                            searchResponse.getHitsList().forEach((hit) => {
                                if (hit.getSupplier() !== Supplier.SUPPLIER_ZANDERS) {
                                    hits.push(hit);
                                }
                            });
                            this.setState({
                                supplierProducts: hits,
                            });
                        } else {
                            this.setState({
                                errorMessage: convertErrorMessage(err),
                            });
                            console.error('while searching suppliers: ' + err);
                        }
                    });
                }
            } else {
                if (err.code === grpcWeb.StatusCode.UNAUTHENTICATED || err.code === grpcWeb.StatusCode.PERMISSION_DENIED) {
                    logOut();
                } else {
                    this.setState({
                        errorMessage: convertErrorMessage(err),
                    });
                    console.error(err);
                }
            }
        });
    }

    render() {
        if (!getUser()) {
            return <div>Redirecting...</div>;
        }
        if (this.state.product) {
            const originals = Product.originalImages('suppliers/zanders', this.state.product.images)
            const images = Product.pruneImages(originals);
            return <Product product={this.state.product}
                images={images}
                errorMessage={this.state.errorMessage}
                supplierProducts= {this.state.supplierProducts}
                imagePrefix='suppliers/zanders'
                manufacturerFilterPrefix='/zanders?f=manufacturer' />
        }
        return <></>;
    }
}

export default withRouter(ZandersProduct);
